import { logToSentry } from 'core/utils/sentry';
import { generatePath } from 'react-router-dom';

function useDynamicPath() {
  function getDynamicPath(routeKey, params = {}, queryParams = {}) {
    let path = '/not-found';
    try {
      const template = routeKey;
      path = generatePath(template, params);
      if (Object.keys(queryParams).length > 0) {
        const searchParams = new URLSearchParams(queryParams).toString();
        path += `?${searchParams}`;
      }
    } catch (e) {
      // TAN-7980: generatePath lanza si falta algún :param requerido (p.ej. un guid undefined
      // en el payload de una notificación), y el usuario acaba en /not-found sin contexto.
      // Logueamos el routeKey y los params para identificar qué parámetro faltaba.
      console.error(`Error generating path for ${routeKey}:`, e);
      logToSentry('error', 'getDynamicPath: generatePath failed, redirecting to /not-found', {
        tags: { feature: 'navigation', reason: 'generate_path_failed' },
        extra: { routeKey, params, queryParams, errorMessage: e?.message },
      });
    }

    return path;
  }

  return { getDynamicPath };
}

export default useDynamicPath;
